import { useEffect, useMemo } from 'react';
import { forbidExtraProps } from 'airbnb-prop-types';

import { useLocation } from 'react-router';

import { useAppDispatch as useDispatch, useAppSelector as useSelector } from 'dux/app/hooks';

import flow from 'lodash/fp/flow';
import get from 'lodash/fp/get';
import split from 'lodash/fp/split';

import * as checkoutStatus from '../constants/checkoutStatus';

import LoadingScene from 'Scenes/LoadingScene';
import CheckoutCompletedScene from '../Scenes/CheckoutCompletedScene';
import CheckoutErrorScene from '../Scenes/CheckoutErrorScene';
import CheckoutIdleScene from '../Scenes/CheckoutIdleScene';
import CheckoutScene from '../Scenes/CheckoutScene';

import * as trackingActions from 'dux/tracking/actions';
import * as checkoutSelectors from 'dux/checkout/selectors';

const getCurrentStepFromPathname = flow(split('/'), get('[3]'));

// For status specific logic report to each scene
const componentForStatus = {
  [checkoutStatus.ERROR]: CheckoutErrorScene,
  [checkoutStatus.FINISHED]: CheckoutCompletedScene,
  [checkoutStatus.IDLE]: CheckoutIdleScene,
  [checkoutStatus.LOADING]: LoadingScene,
  [checkoutStatus.SAVING]: CheckoutScene,
  [checkoutStatus.SUCCESS]: CheckoutScene,
};

const CheckoutContainer = () => {
  const { pathname, search } = useLocation();
  const dispatch = useDispatch();
  // Get useful information from URL that we will pass through whole children hierarchy
  const params = useMemo(() => new URLSearchParams(search), [search]);
  const step = useMemo(() => getCurrentStepFromPathname(pathname), [pathname]);
  // Get status from state
  const status = useSelector(checkoutSelectors.getCheckoutStatusWithSavedPayments);

  // Track current step for analytics
  useEffect(() => {
    dispatch(trackingActions.trackPaymentStep(step));
  }, [step]);

  // Select the right Component to render depending on checkout status
  const CheckoutComponent = componentForStatus[status] || CheckoutErrorScene;

  // Inject URL infos as props to checkout component
  return <CheckoutComponent params={params} step={step} />;
};

CheckoutContainer.propTypes = forbidExtraProps({});

export default CheckoutContainer;
